<template>
  <div>
    <view-table
        ref="viewTable"
        :filter="filter"
        :limits="limits"
        :columns-property="columnsProperty"
        module="basic"
        url="purchaseReceiveDetails"
        @delete="deleteHandle"
        @addOrEdit="addEditHandle"
        @select="selectHandle"
        @reset="resetHandle">
      <template slot="otherBtn">
        <el-button
            v-if="printAuth"
            :loading="printLoading"
            type="primary"
            :disabled="selection.length !== 1"
            @click="printPurchaseReceive">
          打印送货单
        </el-button>
        <el-button
            v-if="deleteAuth"
            :loading="delLoading"
            type="danger"
            :disabled="selection.length !== 1"
            @click="deleteByIds">
          删除
        </el-button>
      </template>
      <template slot="adSearch">
        <el-form ref="form" :inline="true" :model="filter" label-width="80px" @keyup.enter.native="loadData(1)">
          <el-form-item label="送货单号">
            <el-input v-model="filter.no" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="供应商名称">
            <el-input v-model="filter.supplierName" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="供应商编号">
            <el-input v-model="filter.supplierNo" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="采购单号">
            <el-input v-model="filter.purchaseOrderNo" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="物料编号" label-width="80px">
            <el-input v-model="filter.materialNo" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="物料描述" label-width="80px">
            <el-input v-model="filter.materialName" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="规格型号">
            <el-input v-model.trim="filter.specification" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="状态">
<!--            <el-select v-model="filter.status">-->
<!--              <el-option label="草稿" :value="0"/>-->
<!--              <el-option label="已提交" :value="10"/>-->
<!--              <el-option label="已到货" :value="20"/>-->
<!--              <el-option label="已检验" :value="30"/>-->
<!--              <el-option label="已入库" :value="50"/>-->
<!--              <el-option label="退回" :value="90"/>-->
<!--            </el-select>-->
            <el-select
                v-model="biddingStage"
                :popper-append-to-body="false"
                class="biddingStageSty"
                multiple
                clearable
                placeholder="请选择"
                @change="handleSelect">
              <el-option v-for="item in options" :key="item.value" :label="item.name" :value="item.value"/>
            </el-select>
          </el-form-item>
          <el-form-item label="制单日期">
            <el-date-picker
                v-model="createDateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="dateRangeChange('createDateRange', 'createDateBegin', 'createDateEnd')"/>
          </el-form-item>
          <el-form-item label="要求交期">
            <el-date-picker
                v-model="deliveryDateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="dateRangeChange('deliveryDateRange', 'deliveryDateBegin', 'deliveryDateEnd')"/>
          </el-form-item>
          <el-form-item label="制单人">
            <el-input v-model.trim="filter.creatorName" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="首次送货">
            <el-select v-model="filter.isSuspended">
              <el-option label="全部" :value="-1"/>
              <el-option label="是" :value="1"/>
              <el-option label="否" :value="0"/>
            </el-select>
          </el-form-item>
        </el-form>
      </template>
      <template slot="actionBtn" slot-scope="row">
        <el-button
            v-if="submitAuth"
            type="primary"
            :disabled="row.row.status !== 0&&row.row.status!==20"
            @click="suspend(row.row)">
          提交
        </el-button>
        <!--        <el-button-->
        <!--            v-if="submitAuth"-->
        <!--            type="primary"-->
        <!--            :disabled="row.row.status !== 10 && row.row.status!==30"-->
        <!--            @click="cancel(row.row)">-->
        <!--          撤销-->
        <!--        </el-button>-->
      </template>
    </view-table>
    <purchase-receiving-detail-edit ref="editPage" @save-success="loadData(1)"/>
  </div>
</template>

<script>
  import ViewTable from "@/components/ViewTable";
  import PurchaseReceivingDetailEdit from "./PurchaseReceivingDetailEdit";

  export default {
    name: "PurchaseReceivingDetailList",
    components: {ViewTable, PurchaseReceivingDetailEdit},
    data() {
      return {
        submitLoading: false,
        cancelLoading: false,
        printLoading: false,
        delLoading: false,
        ids: [],
        selection: [],
        createDateRange: [],
        deliveryDateRange: [],
        biddingStage: [],
        options: [
          {name: "草稿", value: 0},
          {name: "已提交", value: 10},
          {name: "已到货", value: 20},
          {name: "已检验", value: 30},
          {name: "已入库", value: 40},
        ],
        limits: {
          editAuth: this.$auth(94),
          delAuth: this.$auth(232),
          addAuth: this.$auth(94),
        },
        deleteAuth: this.$auth(232),
        detailAuth: this.$auth(233),
        printAuth: this.$auth(97),
        submitAuth: this.$auth(95),
        filter: {
          no: "",
          supplierNo: "",
          supplierName: "",
          purchaseOrderNo: "",
          materialNo: "",
          materialName: "",
          specification: "",
          status: -1,
          poReceiveStatus: -1,
          isSuspended:-1,
          deliveryDateBegin: "",
          deliveryDateEnd: "",
          createDateBegin: "",
          createDateEnd: "",
          creatorName: "",
          statuses: "",
        },
        columnsProperty: [
          {
            key: "materialName",
            align: "center",
            width: 400,
          },
          {
            key: "action",
            slot: "action",
            fixed: "right",
            align: "center",
            width: 240,
          },
        ],
      };
    },
    watch: {
      "filter.statuses": {
        handler(val) {
          if (val) {
            this.biddingStage = [];
            this.options.map(item => {
              val.split(",").forEach((s) => {
                if (parseInt(s) === parseInt(item.value)) {
                  this.biddingStage.push(item.value);
                }
              });
            });
          }
        },
      },
      "filter.createDateBegin": {
        handler(newVal) {
          if (newVal) {
            this.createDateRange = [];
            this.createDateRange.push(this.filter.createDateBegin);
            this.createDateRange.push(this.filter.createDateEnd);
          }
        },
      },
      "filter.deliveryDateBegin": {
        handler(newVal) {
          if (newVal) {
            this.deliveryDateRange = [];
            this.deliveryDateRange.push(this.filter.deliveryDateBegin);
            this.deliveryDateRange.push(this.filter.deliveryDateEnd);
          }
        },
      },
    },
    methods: {
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      // 新增、编辑
      addEditHandle(row) {
        this.$refs.editPage.open(row);
      },

      //订单提交
      suspend(row) {
        this.submitLoading = true;
        this.$confirm("确定提交吗?", "提示", {type: "warning"})
            .then(() => {
              this.$http.get("basic", "purchaseReceives/submitPurchaseReceive/" + row.mastPKID).then((res) => {
                if (res.success) {
                  this.loadData(1);
                  this.$message.success("提交成功");
                  this.submitLoading = false;
                }
              });
            })
            .catch(() => {
              this.submitLoading = false;
            });
      },

      //订单提交
      cancel(row) {
        this.submitLoading = true;
        this.$confirm("确定提交吗?", "提示", {type: "warning"})
            .then(() => {
              this.$http.get("basic", "purchaseReceives/rejectPurchaseReceive/" + row.mastPKID).then((res) => {
                if (res.success) {
                  this.loadData(1);
                  this.$message.success("撤销成功");
                }
                this.submitLoading = false;
              });
            })
            .catch(() => {
              this.submitLoading = false;
            });
      },
      dateRangeChange(timeRange, timeStart, timeEnd) {
        if (this[timeRange]) {
          this.filter[timeStart] = this[timeRange][0];
          this.filter[timeEnd] = this[timeRange][1];
        } else {
          this.filter[timeStart] = "";
          this.filter[timeEnd] = "";
        }
      },
      handleSelect(value) {
        if (value.length) {
          this.biddingStage = value;
          this.filter.statuses = value.join(",");
        } else {
          this.biddingStage = [];
          this.filter.statuses = "";
        }
      },
      selectHandle(selection) {
        this.selection = selection;
        this.selection.forEach(item => {
          this.ids.push(item.mastPKID);
        });
      },

      // 打印发货单
      printPurchaseReceive() {
        this.printLoading = true;
        this.$http
            .postForFile("basic", "purchaseReceives/printPurchaseReceiveVO", this.ids)
            .then((res) => {
              let blob = new Blob([res.data], {type: "application/pdf"});
              let pdfUrl = window.URL.createObjectURL(blob);
              window.open(pdfUrl);
              this.printLoading = false;
              this.selection = [];
              this.ids = [];
              this.loadData();
            })
            .catch(() => {
              this.printLoading = false;
            });
      },

      // 订单删除
      deleteByIds() {
        this.delLoading = true;
        this.$http.get("basic", `purchaseReceives/deleteByIds/${this.ids}`).then((res) => {
          if (res.success) {
            this.loadData(1);
            this.$message.success("删除成功");
          }
          this.delLoading = false;
        }).catch(() => {
          this.delLoading = false;
        });
      },


      // 行项删除
      deleteHandle(row) {
        this.$http.get("basic", `purchaseReceiveDetails/deletePurchaseReceive/${row.pkid}`).then((res) => {
          if (res.success) {
            this.loadData(1);
            this.$message.success("删除成功");
          } else {
            this.$message.error(res.message);
          }
        });
      },

      // 重置
      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },

      // 只能编辑和删除未提交的数据
      otherAuth(row) {
        if (row.status >= 10) {
          return {
            editAuth: true,
            delAuth: true,
          };
        } else {
          return {
            editAuth: false,
          };
        }
      },
    },
  };
</script>

<style scoped>
</style>
